import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { Unit } from '../../models/unit';
import { FormBuilder, FormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import each from 'lodash-es/each';

@Component({
  selector: 'mj-unit-parent',
  templateUrl: 'unit-parent.component.html',
  styleUrls: ['unit-parent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitParentComponent implements OnChanges {
  @Input() unit: Unit;
  @Input() units: Array<any>;
  @Output() updateParent: EventEmitter<Unit> = new EventEmitter<Unit>();
  form: FormGroup;
  unitChildren;

  constructor(
    private fb: FormBuilder,
    private snackbar: MatSnackBar,
    private ref: ChangeDetectorRef
  ) {
    this.form = fb.group({
      parentId: '',
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.unit && this.unit) {
      this.form.patchValue({
        parentId: this.unit.parent_id,
      });
      this.form.updateValueAndValidity();
      this.form.markAsPristine();
    }
    if (this.units && this.units.length && this.unit) {
      this.unitChildren = this.findUnitById(this.units, this.unit.id);
    }
  }

  findUnitById(arr, id) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].id === id) {
        return arr[i];
      }
      const found = this.findUnitById(arr[i].children, id);
      if (found) {
        return found;
      }
    }
  }

  setNewParent(e: any) {
    // i know its ugly, but we need this - sometimes new unit is faster than units
    // and unit dropdown doesnt work then
    this.ref.detectChanges();
    if (this.form.pristine && !e.isUserInput) {
      return;
    }
    if (e.source.value !== this.unit.parent_id) {
      const newParentName = this.filteredUnitList.find(
        u => u.id === e.source.value
      );
      // tslint:disable-next-line:max-line-length
      this.snackbar
        .open(
          `Please confirm changing parent of ${
            this.unit.name
          } to ${(newParentName && newParentName.name) || '<no parent>'}`,
          'Yes',
          {
            panelClass: ['snackbar-50', 'snackbar-danger'],
            duration: 4000,
          }
        )
        .afterDismissed()
        .pipe(take(1))
        .subscribe(ev => {
          if (ev.dismissedByAction) {
            this.updateParent.emit({
              ...this.unit,
              parent_id: this.parentId,
            });
          } else {
            this.form.markAsPristine();

            this.form.patchValue({
              parentId: this.unit.parent_id,
            });
          }
        });
    }
  }

  compareUnits(c1: any, c2: any): boolean {
    return c1 && c2 ? c1 === c2 : c1 === c2;
  }

  private _flatten(collection: any[], flattened = []) {
    const self = this;
    if (flattened == null) {
      flattened = [];
    }
    each(collection, function(obj) {
      flattened.push(obj);
      return self._flatten(obj.children, flattened);
    });
    return flattened;
  }

  public trackByFn(index, item) {
    return index;
  }

  get parentId() {
    return this.form.value.parentId;
  }

  get filteredUnitList() {
    return (
      (this.units &&
        this.units.length &&
        this._flatten(this.units, []).filter(u => u.id !== this.unit.id)) ||
      []
    );
  }
}
